import { useContext } from 'react'
import { WorkoutTemplateBuilderContext } from '../../WorkoutTemplateBuilder'
import { ChevronUpIcon, ChevronDownIcon } from '@heroicons/react/24/solid'

import PlusMinusButtonChanger from 'components/WorkoutTemplateBuilder/Components/PlusMinusButtonChanger'

export default function CircuitRoundsButton({ phase, phaseIndex }) {
    const { mode, mutatePhase, previousWeekWorkoutTemplateJSON } = useContext(WorkoutTemplateBuilderContext)

    switch (mode) {
        // Edit mode
        case 'edit':
            if (phase.type === 'circuit') {
                return (
                    <div className="h-8 px-2 flex items-center gap-x-2 justify-center border-x border-stone-400 text-xs">
                        <div>Circuit Rounds: </div>

                        <PlusMinusButtonChanger
                            label="Circuit Rounds:"
                            value={phase.circuitRounds}
                            handleAddFunction={() => mutatePhase('add-circuit-round', phaseIndex)}
                            handleSubtractFunction={() => mutatePhase('subtract-circuit-round', phaseIndex)}
                        />
                    </div>
                )
            }

            break

        // View mode
        case 'view':
            if (phase.type === 'circuit') {
                return (
                    <div className="h-8 px-2 flex items-center justify-center border-x border-stone-400 text-xs">
                        <div>Circuit Rounds: {phase.circuitRounds}</div>

                        {/* Week over week circuit round changes */}
                        {previousWeekWorkoutTemplateJSON !== null && phase.circuitRounds !== previousWeekWorkoutTemplateJSON.phases[phaseIndex].circuitRounds && (
                            <div className="flex items-center gap-x-1 bg-orange-400 ml-1 px-2 text-white font-bold rounded-md">
                                {phase.circuitRounds - previousWeekWorkoutTemplateJSON.phases[phaseIndex].circuitRounds > 0 && <ChevronUpIcon className="text-white h-3" />}

                                {phase.circuitRounds - previousWeekWorkoutTemplateJSON.phases[phaseIndex].circuitRounds < 0 && <ChevronDownIcon className="text-white h-3" />}

                                {Math.abs(phase.circuitRounds - previousWeekWorkoutTemplateJSON.phases[phaseIndex].circuitRounds)}
                            </div>
                        )}
                    </div>
                )
            }

            break

        // Error Message
        default:
            console.error(mode + ' is not a valid mode!!')
    }
}
